import * as _ from 'lodash';

let ErrorService = {
  /**
   *
   * @param error
   * @return {*[]}
   */
  getErrorMessages: function(error) {
    let messages = [];

    if (!error) {
      return messages;
    }

    if (_.isString(error)) {
      messages.push(error);
    } else if (_.isString(error.message)) {
      if (!_.isEmpty(error.errors) && Object.keys(error.errors).length > 0) {
        _.map(error.errors, (value, key) => {
          if (key !== 'code') {
            messages.push(String(value));
          }
        });
      }
      if (messages.length === 0 && !_.isEmpty(error.message)) {
        messages.push(error.message);
      }
    } else {
      messages.push(String(error));
    }

    return messages;
  },
};

export default ErrorService;
